import React from "react";

import { toDisplayLabel, splitAnswerTokens, isKnownSourceName } from "./formLogic";

/**
 * A form label shown the way it is authored: {{field:<id>}} tokens rendered as
 * {{answer: <the question they pull from>}}, the same text the label editor
 * puts in its input. Ids are stored (they survive renames), never displayed.
 *
 * Shared by the authoring surfaces that show a label read-only — the field rail
 * today — so a question can't read one way there and another way on its card.
 * A token whose source no longer comes earlier stays in raw {{field:…}} form
 * and renders red, matching the warning under the card.
 */
export default function PipedLabel({ text, earlierFields }) {
  const display = toDisplayLabel(text, earlierFields);
  return (
    <>
      {splitAnswerTokens(display).map((seg, i) =>
        // Violet only while the token still names a question that comes before
        // this one. Editing inside one leaves plain text that merely looks like
        // a variable, and it has to read that way here too, exactly as it does
        // on the card.
        seg.token && isKnownSourceName(seg.name, earlierFields) ? (
          <span key={i} className="text-violet-700">
            {seg.token}
          </span>
        ) : (
          <span
            key={i}
            className={(seg.text || "").includes("{{field:") ? "text-red-600" : ""}
          >
            {seg.token || seg.text}
          </span>
        )
      )}
    </>
  );
}
